/**
 * User Info Replacer View
 */

define(function(require, exports, module) {
    'use strict';
    var BaseReplacerView = require('common/base.replacer.view');
    var user = require('user');

    module.exports = BaseReplacerView.extend({

        tagName: 'span',

        className: 'user-info-replacer',

        accessRules: {
            allow: ['user']
        },

        render: function(param) {
            var userDetails = user.get('userDetails');

            this.$el.html(userDetails[param]);

            return this;
        }
    }, {
        nameOfReplacers: [
            'USER_INFO'
        ]
    });
});
